import CopyCellRenderer from "components/tables/AGGrid/CustomCells/CopyCellRenderer";

export const 
approvalCodesColumns = [
    {
        title: 'Name',
        field: 'name',
    },
    {
        title: 'Approval Code',
        field: 'code',
    },
    {
        title: 'Auto Approval',
        field: 'autoApprove',
        cellRenderer: rowData => {
            // 0: None, 1: Trial, 2: Live
            if (rowData.autoApprove === 1) return 'Trial';
            if (rowData.autoApprove === 2) return 'Live';
            return 'None';
        },
    },
    {
        title: 'Customer Default Plan',
        field: 'planName',
    },
    {
        title: 'Trial Duration (days)',
        field: 'trialDays',
    },
    {
        title: 'Selective Sync Policy',
        field: 'selectiveSyncPolicy',
        cellRenderer: rowData => {
            // 0: Disabled, 1: Enabled, 2: Forced
            if (rowData.selectiveSyncPolicy === 1) return 'Enabled';
            if (rowData.selectiveSyncPolicy === 2) return 'Forced';
            return 'Disabled';
        },
    },
    {
        title: 'Approval Code Expiry Date',
        field: 'validTo',
         valueFormatter: (params) => {
                            if (!params.value) return '';
                            const date = new Date(params.value);
                            if (isNaN(date.getTime())) return params.value;
                            // Format: Fri, 26 Feb 2021, 11:42:11 pm UTC
                            const dayName = date.toLocaleString('en-GB', { weekday: 'short', timeZone: 'UTC' });
                            const day = date.toLocaleString('en-GB', { day: '2-digit', timeZone: 'UTC' });
                            const month = date.toLocaleString('en-GB', { month: 'short', timeZone: 'UTC' });
                            const year = date.toLocaleString('en-GB', { year: 'numeric', timeZone: 'UTC' });
                            let hour = date.getUTCHours();
                            let minute = date.getUTCMinutes();
                            let second = date.getUTCSeconds();
                            let hour12 = hour % 12 || 12;
                            let ampm = hour < 12 ? 'am' : 'pm';
                            const pad = (n) => n.toString().padStart(2, '0');
                            return `${dayName}, ${pad(day)} ${month} ${year}, ${pad(hour12)}:${pad(minute)}:${pad(second)} ${ampm} UTC`;
                        },
                        cellRenderer: (params) => {
                            // Show formatted value, but copy raw value
                            const date = new Date(params.value);
                            if (isNaN(date.getTime())) return params.value;
                            // Format: Fri, 26 Feb 2021, 11:42:11 pm UTC
                            const dayName = date.toLocaleString('en-GB', { weekday: 'short', timeZone: 'UTC' });
                            const day = date.toLocaleString('en-GB', { day: '2-digit', timeZone: 'UTC' });
                            const month = date.toLocaleString('en-GB', { month: 'short', timeZone: 'UTC' });
                            const year = date.toLocaleString('en-GB', { year: 'numeric', timeZone: 'UTC' });
                            let hour = date.getUTCHours();
                            let minute = date.getUTCMinutes();
                            let second = date.getUTCSeconds();
                            let hour12 = hour % 12 || 12;
                            let ampm = hour < 12 ? 'am' : 'pm';
                            const pad = (n) => n.toString().padStart(2, '0');
                            const formatted = `${dayName}, ${pad(day)} ${month} ${year}, ${pad(hour12)}:${pad(minute)}:${pad(second)} ${ampm} UTC`;
                            return CopyCellRenderer({ value: params.data.dateTime, valueFormatted: formatted });
                        },
    },
];

export const validationSchema = {
    name: [{type: 'isEmpty', message: 'Please enter a valid name.'}],
    code: [
        {
            type: 'isLength',
            message: 'Please enter a minimum of 6 characters.',
            conditions: {min: 6},
        },
    ],
    trialDays: [
        {
            type: 'isEmpty',
            message: 'Please enter how many days your trial will last.',
        },
    ],
    planID: [
        {
            type: 'isEmpty',
            message: 'Please select a Partner Plan.',
        },
    ],
    selectiveSyncPolicy: [
        {
            type: 'isEmpty',
            message: 'Please select a Selective Sync Policy.',
        },
    ],
};

    export const selectiveSyncOptions = [
        { value: 0, label: 'Disabled' },
        { value: 1, label: 'Enabled' },
        { value: 2, label: 'Forced' },
    ];
    export const autoApprovalOptions = [
        {
            value: 0,
            label: 'None',
        },
        {
            value: 1,
            label: 'Trial',
        },
        {
            value: 2,
            label: 'Live',
        },
    ];
